export class room_passenger {
    public index: number | null = null;
}